<template>
    <ExecutivePopover v-if="isExecutive" :value="entity" />
    <CompanyPopover v-else-if="isCompany" :value="entity" />
</template>
<script setup>
import ExecutivePopover from './executive-popover.vue'
import CompanyPopover from './company-popover.vue'

const props = defineProps({
    value: {
        type: Object,
        default() {
            return {}
        },
    },
})

const entity = computed(() => props.value.entity)
const entityType = computed(() => props.value.type)
const isCompany = computed(() => entityType.value === 'Company')
const isExecutive = computed(() => entityType.value === 'Executive')
</script>
